import React, { useEffect, useState } from "react";
import { OrderServices } from "../../../core/services/OrderServices";
import { StoreServices } from "../../../core/services/StoreServices";
import { UserServices } from "../../../core/services/UserServices";
import {
  Button,
  Container,
  Content,
  DatePicker,
  Header,
  InputGroup,
  Loader,
  Panel,
  Radio,
  RadioGroup,
  SelectPicker,
} from "rsuite";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import "./Order.css";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import {
  appConstObj,
  dateFormatObj,
  dayTimeObjArr,
  messageTypeArr,
  orderConfObj,
  orderServeAtObj,
  orderStatusObj,
  orderStatusObjArr,
  paymentModeObjArr,
  roleTypeArr,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useSelector } from "react-redux";
import { Field, Form, FormSpy } from "react-final-form";
import { ValidatorCustom } from "./../../validators/ValidatorCustom";
import {
  calenderDateToDB,
  dateFormat,
  dbDateToCalender,
  displayAmountField,
  getHourMinuteFormat,
  isEmptyVal,
  isNotNull,
} from "../../../utils/helpers";
import CustomerFinder from "../Customers/CustomerFinder";
import { get, pick } from "lodash/fp";
import { updateIn } from "json-immut/updateIn";
import moment from "moment";
import OrderScheduleForDay from "./OrderScheduleForDay";
import StoreProductsForOrder from "../Products/StoreProductsForOrder";
import OrderServiceItems from "./OrderServiceItems";

const OrderStepOne = () => {
  const { t } = useTranslation();
  const [checkingSchedule, setCheckingSchedule] = useState(false);
  const [loader, setLoading] = useState(false);
  const [stopSubmit, setStopSubmit] = useState(false);
  const [productForGender, setProductForGender] = useState("");
  const [customerData, setCustomerData] = useState<any>({});
  const [products, setProducts] = useState<any[]>([]);
  const [assignedToList, setAssignedToList] = useState([]);
  const [orderItems, setOrderItems] = useState<any[]>([]);
  const [orderServiceItems, setOrderServiceItems] = useState<any[]>([]);
  const [orderAmount, setOrderAmount] = useState<number>(0.0);
  const [orderOriginalAmount, setOrderOriginalAmount] = useState<number>(0.0);
  const [priceVariance, setPriceVariance] = useState<number>(0.0);
  const [orderAmountAfterDiscount, setOrderAmountAfterDiscount] =
    useState<number>(0.0);
  const [totalDiscount, setTotalDiscount] = useState<number>(0.0);
  const [finalDiscountPercent, setFinalDiscountPercent] = useState<number>(0.0);
  const [orderTax, setOrderTax] = useState<number>(0.0);
  const [editOrderCompany, setEditOrderCompany] = useState<number>();
  const [orderPayableAmount, setOrderPayableAmount] = useState<number>(0.0);
  const [showCustFinder, setShowCustFinder] = useState(true);
  const [showSchedule, setShowSchedule] = useState(false);
  const [showItemGrid, setShowItemGrid] = useState<boolean>(false);
  const toggleCustFinder = () => setShowCustFinder(!showCustFinder);
  const toggleSchedule = (display?: any) => {
    if (display !== null && display !== undefined) {
      setShowSchedule(display);
    } else setShowSchedule(!showSchedule);
  };
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [storeList, setStoreList] = useState([]);
  const navigate = useNavigate();
  let [decryptedParams] = useDecryptedParams(params);
  const company = useSelector((state: any) => state.company);
  const isEditMode = !!decryptedParams.id;
  const initSearchFormData: any = {
    customer_id: "",
    company_id: "",
    store_id: UtilityServices.getLoggedInUser("store_id"),
    order_serve_at: orderServeAtObj.store.value,
    service_date: new Date(moment().format(dateFormatObj.moment_y_m_d)),
    service_starts_at: "",
    order_status: orderStatusObj.served.value,
    order_assigned_to: "",
    served_by: "",
    remarks: "",
    additional_cost: "",
    discount_percent: "",
    additional_discount: "",
    payment_mode: "",
    customer_order_note: "",
    service_rating: "",
    customer_feedback: "",
    manager_feedback: "",
    order_cancellation_reason: "",
    cancelled_at: "",
  };
  const [formData, setFormData] = useState<any>(initSearchFormData);

  const handleServiceItemChange = (updatedItems: any[]) => {
    setOrderServiceItems([...updatedItems]);

    const highestPricedItem = updatedItems
      .filter((item) => item.item_assigned_to)
      .reduce((maxItem, currentItem) => {
        const currentPrice = Number(currentItem.item_service_price) || 0;
        const maxPrice = Number(maxItem?.item_service_price) || 0;
        return currentPrice > maxPrice ? currentItem : maxItem;
      }, null);

    if (highestPricedItem?.item_assigned_to) {
      setFormData((prev: any) => ({
        ...prev,
        order_assigned_to: highestPricedItem.item_assigned_to,
      }));
    }
  };

  function setServiceItemsAssignedTo(value: number) {
    if (!Array.isArray(orderServiceItems) || !orderServiceItems.length) return;

    const maxPrice = Math.max(
      ...orderServiceItems
        .filter((item) => item.item_assigned_to === null)
        .map((item) => Number(item.item_service_price)),
    );

    const updatedItems = orderServiceItems.map((item) => {
      //  if (
      //   item.item_assigned_to === null &&
      //   Number(item.item_service_price) === maxPrice
      // )

      if (item.item_assigned_to === null) {
        return {
          ...item,
          item_assigned_to: value,
        };
      }
      return item;
    });
    setOrderServiceItems?.(updatedItems);
  }

  function getProductsFromOrderItems(items: any[]) {
    const results: any[] = [];
    let product: any = {};
    items.forEach(function (value: any) {
      value["id"] = value["store_product_id"];
      product = value;
      results.push(product);
    });
    return results;
  }

  useEffect(() => {
    setStoreList([]);
    setAssignedToList([]);
  }, []);

  useEffect(() => {
    if (+decryptedParams?.id > 0) {
      init();
    }
  }, [decryptedParams]);

  useEffect(() => {
    if (!params?.id) {
      init();
    }
  }, [company]);

  async function init() {
    try {
      setShowItemGrid(formData.store_id > 0 ? true : false);
      if (decryptedParams.id) {
        setLoading(true);

        const response: any = await OrderServices.viewOrder(
          +decryptedParams.id,
        );
        const respData = get("data.data", response);
        let obj = { ...formData };
        const ignoreKeys: string[] = [
          "order_items",
          "store",
          "served_by_detail",
          "assigned_to",
        ];
        const amountFields = [
          "additional_cost",
          "additional_discount",
          "discount_percent",
          "discount_total",
          "order_price",
          "order_tax",
          "order_price_with_tax",
          "order_final_payable",
        ];
        Object.keys(obj).map((formKey) => {
          if (!ignoreKeys.includes(formKey)) {
            if (formKey == "customer_id") {
              setCustomerData(respData["customer"]);
            } else if (formKey == "company_id") {
              setEditOrderCompany(respData["company_id"]);
              obj["company_id"] = respData["company_id"];
            } else if (formKey == "service_date") {
              obj["service_date"] = dbDateToCalender(respData["service_date"]);
            } else if (formKey == "final_discount_percent") {
              setFinalDiscountPercent(respData[formKey]);
              obj[formKey] = respData[formKey];
            } else if (formKey == "service_starts_at") {
              obj["service_starts_at"] = getHourMinuteFormat(
                respData["service_starts_at"],
              );
            } else if (amountFields.includes(formKey)) {
              obj[formKey] = displayAmountField(respData[formKey]);
            } else if (respData[formKey]) {
              obj[formKey] = respData[formKey];
            }
          }
        });
        setFormData({ ...obj });
        if (respData?.order_service_items.length > 0) {
          setOrderServiceItems(respData?.order_service_items);
        }
        if (respData?.order_items.length > 0) {
          setOrderItems(respData["order_items"]);
          onProductChange(
            getProductsFromOrderItems(respData["order_items"]),
            {
              ...obj,
            },
            true,
          );
        }
        if (respData?.order_service_items.length > 0) {
          setOrderServiceItems(respData["order_service_items"]);
        }
        if (obj?.store_id > 0) {
          handleFormChanges({ path: "store_id", value: obj?.store_id });
          setShowItemGrid(true);
        }
        if (obj?.company_id > 0) {
          storeSearch("", obj.company_id);
          assignedToSearch("", obj.company_id);
        }
        setFormData({ ...obj });
        setLoading(false);
      } else {
        checkCompanySelected();
        toggleSchedule(false);

        storeSearch("");
        assignedToSearch("");
        setFormData(initSearchFormData);
      }
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
      navigate(ContentRoutes.ORDERS);
    }
  }

  const applyDiscount = (basePrice: number, discountPercent: number) => {
    if (!basePrice || !discountPercent) return basePrice;
    return Number((basePrice - (basePrice * discountPercent) / 100).toFixed(2));
  };

  function generateServiceItemsFromProducts(
    products: any[],
    orderAssignedTo: any = null,
    existingServiceItems: any[] = [],
    finalDiscountPercent: number = 0,
    skipDiscount: boolean = false,
  ) {
    const serviceItems: any[] = [];

    if (!Array.isArray(products) || products.length === 0) {
      setOrderServiceItems([]);
      return [];
    }

    const findExisting = (
      product_id: number,
      parent_product_id: number | null,
      qty_no: number,
    ) =>
      existingServiceItems.find(
        (it) =>
          it.product_id === product_id &&
          it.parent_product_id === parent_product_id &&
          it.qty_no === qty_no,
      );

    products.forEach((product) => {
      const qty = Number(product.product_qty) || 1;

      if (product.has_sub_products == "0") {
        for (let i = 1; i <= qty; i++) {
          const existing = findExisting(product.product_id, null, i);

          const basePrice =
            existing?.item_base_price ??
            existing?.item_service_price ??
            product.product_price;

          const finalPrice = skipDiscount
            ? basePrice
            : applyDiscount(basePrice, finalDiscountPercent);

          serviceItems.push({
            product_id: product.product_id,
            parent_product_id: null,
            item_name: product.product_name,
            item_identifier: `${product.product_name}_${i}`,
            qty_no: i,
            item_service_price: finalPrice,
            item_base_price: basePrice,
            item_assigned_to: existing?.item_assigned_to ?? orderAssignedTo,
            item_served_by: existing?.item_served_by ?? null,
            item_served_at: existing?.item_served_at ?? null,
            item_service_rating: existing?.item_service_rating ?? null,
            customer_service_feedback:
              existing?.customer_service_feedback ?? null,
            manager_service_feedback:
              existing?.manager_service_feedback ?? null,
          });
        }
        return;
      }

      if (!Array.isArray(product.sub_products)) return;

      product.sub_products.forEach((subProduct: any) => {
        for (let i = 1; i <= qty; i++) {
          const existing = findExisting(
            subProduct.product_id,
            product.product_id,
            i,
          );

          const basePrice =
            existing?.item_base_price ??
            existing?.item_service_price ??
            subProduct.product_price;

          const finalPrice = skipDiscount
            ? basePrice
            : applyDiscount(basePrice, finalDiscountPercent);

          serviceItems.push({
            product_id: subProduct.product_id,
            parent_product_id: product.product_id,
            item_name: subProduct.product_name,
            item_identifier: `${subProduct.product_name}_${i}`,
            qty_no: i,
            item_service_price: finalPrice,
            item_base_price: basePrice,
            item_assigned_to: existing?.item_assigned_to ?? orderAssignedTo,
            item_served_by: existing?.item_served_by ?? null,
            item_served_at: existing?.item_served_at ?? null,
            item_service_rating: existing?.item_service_rating ?? null,
            customer_service_feedback:
              existing?.customer_service_feedback ?? null,
            manager_service_feedback:
              existing?.manager_service_feedback ?? null,
          });
        }
      });
    });

    setOrderServiceItems(serviceItems);
    return serviceItems;
  }

  async function checkSchedule() {
    let compId: number = getCompanyId();
    let error: string = "";

    if (!compId) {
      error += t("REQUIRED_SELECT", {
        field: t("COMPANY").toLowerCase(),
      });
    }

    if (isEmptyVal(formData?.service_date)) {
      error += t("REQUIRED", {
        field: t("DATE").toLowerCase(),
      });
    }
    if (isEmptyVal(formData?.store_id)) {
      error += t("REQUIRED_SELECT", {
        field: t("STORE").toLowerCase(),
      });
    }

    if (!isEmptyVal(error)) {
      UtilityServices.showToaster({
        message: error,
        type: messageTypeArr.error,
      });
      return;
    }
    toggleSchedule();
  }
  async function storeSearch(searchStore: string, forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    if (!compId) {
      return;
    }
    try {
      const res = await StoreServices.getStores({
        company: compId,
        smart_search: searchStore,
      });
      const respData = get("data.data", res);
      setStoreList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function assignedToSearch(searchStaff: string, forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    if (!compId) {
      return;
    }
    try {
      const res = await UserServices.getStaffList({
        company: compId.toString(),
        smart_search: searchStaff,
        rows: appConstObj.record_per_page_1000,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        setAssignedToList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function onProductChange(
    products: any[],
    moreFields?: any,
    skipServiceGeneration: boolean = false,
    skipDiscount: boolean = false,
  ) {
    const frmData = { ...formData, ...moreFields };
    setFormData(frmData);
    setProducts(products);
    let orderAmt: number = 0.0,
      orderOrigAmt: number = 0.0,
      orderPayable: number = 0.0,
      priceVariance: number = 0.0,
      orderTax: number = 0.0,
      totalDiscount: number = 0.0,
      discount: number = 0.0,
      orderAmountAfterDiscount: number = 0.0,
      finalDiscountPercent: number = 0.0;
    products.forEach(function (prd: any) {
      if (isEmptyVal(prd["product_price"])) {
        prd["product_price"] = 0.0;
      }

      if (isEmptyVal(prd["product_original_price"])) {
        prd["product_original_price"] = 0.0;
      }
      orderAmt = orderAmt + +prd["product_price"] * +prd["product_qty"];
      orderOrigAmt =
        orderOrigAmt + +prd["product_original_price"] * +prd["product_qty"];
    });

    priceVariance = orderOrigAmt - orderAmt;
    orderAmt = orderAmt + +frmData.additional_cost;
    discount = (orderAmt * +frmData.discount_percent) / 100;
    totalDiscount = discount + +frmData.additional_discount;
    orderAmountAfterDiscount = orderAmt - totalDiscount;
    orderTax = ((orderAmt - totalDiscount) * orderConfObj.tax_percent) / 100;
    orderPayable = orderAmt - totalDiscount + orderTax;
    finalDiscountPercent =
      orderAmt > 0 ? Number(((totalDiscount * 100) / orderAmt).toFixed(2)) : 0;
    setOrderAmount(orderAmt);
    setOrderOriginalAmount(orderOrigAmt);
    setPriceVariance(priceVariance);
    setTotalDiscount(totalDiscount);
    setOrderAmountAfterDiscount(orderAmountAfterDiscount);
    setOrderTax(orderTax);
    setOrderPayableAmount(orderPayable);
    setFinalDiscountPercent(finalDiscountPercent);
    if (!skipServiceGeneration) {
      let sItems = generateServiceItemsFromProducts(
        products,
        null,
        orderServiceItems,
        finalDiscountPercent,
        skipDiscount,
      );
    }
  }

  function checkCompanySelected() {
    if (!getCompanyId()) {
      UtilityServices.showToaster({
        message: t("REQUIRED_SELECT", {
          field: t("COMPANY").toLowerCase(),
        }),
        type: messageTypeArr.error,
      });
    }
  }

  const onSubmit = (val: any, e: any) => {
    if (stopSubmit) return;
    const form = new FormData();
    for (var key in formData) {
      if (key == "service_date") {
        form.append("service_date", calenderDateToDB(val[key]));
      } else if (isNotNull(val[key])) {
        form.append(key, val[key]);
      }
    }

    form.append("products", JSON.stringify(processProductsForOrder(products)));
    const unassignedItem = orderServiceItems.find(
      (item) => item.item_assigned_to == null,
    );

    if (unassignedItem) {
      UtilityServices.showToaster({
        type: "error",
        message: `${t("PLEASE_SELECT_FIELD", {
          field: t("ASSIGNED_TO").toLowerCase(),
        })} (${unassignedItem.item_name})`,
      });
      return;
    }
    form.append("service_items", JSON.stringify(orderServiceItems));

    const totalServiceItemValue = Number(
      orderServiceItems
        .reduce((sum, item) => sum + (Number(item.item_service_price) || 0), 0)
        .toFixed(2),
    );

    if (+orderAmountAfterDiscount < totalServiceItemValue) {
      UtilityServices.showToaster({
        type: "error",
        message: t("LESS_THAN_EQUAL_TO", {
          field: t("SERVICE_ITEMS_VALUE").toLowerCase(),
          value: orderAmountAfterDiscount,
        }),
      });
      return;
    }

    if (!decryptedParams.id) {
      const companyId = getCompanyId();
      if (isEmptyVal(companyId)) {
        UtilityServices.showToaster({
          type: "error",
          message: t("PLEASE_SELECT_FIELD", {
            field: t("COMPANY").toLowerCase(),
          }),
        });
        return;
      } else {
        form.set("company_id", companyId);
      }

      if (isEmptyVal(customerData?.id)) {
        UtilityServices.showToaster({
          type: "error",
          message: t("PLEASE_SELECT_FIELD", {
            field: t("CUSTOMER").toLowerCase(),
          }),
        });
        return;
      } else {
        form.set("customer_id", customerData.id);
      }
    }
    if (products.length < 1) {
      UtilityServices.showToaster({
        type: "error",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("PRODUCT").toLowerCase(),
        }),
      });
      return;
    }

    if (decryptedParams.id) {
      form.delete("company_id");
      form.delete("customer_id");
      saveOrder(form, decryptedParams.id);
    } else {
      saveOrder(form);
    }
  };

  function processProductsForOrder(items: any[]) {
    const results: any[] = [];
    let product: any = {};
    items.forEach(function (value: any) {
      product = pick(["id", "service_note"], value);
      product.qty = value.product_qty;
      results.push(product);
    });
    return results;
  }

  async function saveOrder(form: any, orderId?: any) {
    try {
      setLoading(true);
      let response: any;
      if (orderId) {
        response = await OrderServices.updateOrder(+orderId, form);
      } else {
        response = await OrderServices.createOrder(form);
      }
      setFormData(response?.data?.data);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.ORDERS);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (decryptedParams.id && editOrderCompany) {
      compId = editOrderCompany;
    } else if (company?.id && !decryptedParams.id) {
      compId = company.id;
    }
    return compId;
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    if (!decryptedParams.id) {
      const selectedDate = new Date(date);
      const today = new Date();

      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        frmObj["order_status"] = orderStatusObj.served.value;
      } else if (selectedDate > today) {
        frmObj["order_status"] = orderStatusObj.pending.value;
      }
    }
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  return (
    <div className="order">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      {!loader && (
        <Container className="container">
          <Header className="header">
            <h4>
              {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("ORDER")}
            </h4>
          </Header>
          <Content className="content order-create-wrap mt-3">
            <Form
              onSubmit={onSubmit}
              validate={(values: any) => {
                if (stopSubmit) return;
                const errors: any = {};
                if (!values.store_id) {
                  errors.store_id = t("REQUIRED_SELECT", {
                    field:
                      t("STORE").toLowerCase() + " " + t("NAME").toLowerCase(),
                  });
                }
                if (!values.service_date) {
                  errors.service_date = t("REQUIRED", {
                    field:
                      t("SERVICE").toLowerCase() +
                      " " +
                      t("DATE").toLowerCase(),
                  });
                }
                if (!values.service_starts_at) {
                  errors.service_starts_at = t("REQUIRED_SELECT", {
                    field:
                      t("SERVICE").toLowerCase() +
                      " " +
                      t("TIME").toLowerCase(),
                  });
                }
                if (!values.order_status) {
                  errors.order_status = t("REQUIRED_SELECT", {
                    field:
                      t("ORDER").toLowerCase() +
                      " " +
                      t("STATUS").toLowerCase(),
                  });
                }
                return errors;
              }}
              initialValues={{ ...formData }}
              render={({ handleSubmit, form }) => (
                <>
                  <FormSpy
                    subscription={{ values: true }}
                    onChange={({ values }) => setFormData(values)}
                  />
                  <form onSubmit={handleSubmit}>
                    <div className="address-bx" onClick={toggleCustFinder}>
                      <h5>
                        {t("CUSTOMER")}{" "}
                        <span>
                          {customerData?.name}{" "}
                          {customerData?.mobile && customerData?.mobile}
                        </span>
                      </h5>
                    </div>
                    <div className="form-part">
                      {!params.id && (
                        <Panel
                          header={t("CUSTOMER") + " " + t("FINDER")}
                          collapsible
                          bordered
                          defaultExpanded={true}
                        >
                          <CustomerFinder
                            customerData={customerData}
                            setCustomerData={setCustomerData}
                            customerId={formData.customer_id}
                            setStopSubmit={setStopSubmit}
                            setProductForGender={setProductForGender}
                          />
                        </Panel>
                      )}

                      <div className="flex-container">
                        <Field name="service_date">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("SERVICE")} {t("DATE")}
                              </label>
                              <DatePicker
                                value={formData?.service_date}
                                format={dateFormatObj.calendar_d_m_y}
                                name="service_date"
                                id="service_date"
                                onChange={(e: any) => {
                                  toggleSchedule(false);
                                  handleDateChange(e, "service_date");
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>

                        <Field name="service_starts_at">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("SERVICE")} {t("TIME")}
                              </label>
                              <SelectPicker
                                data={dayTimeObjArr}
                                valueKey="value"
                                labelKey="label"
                                onSelect={(value, item) => {
                                  handleFormChanges({
                                    path: "service_starts_at",
                                    value,
                                  });
                                }}
                                onClean={(e: any) => {
                                  handleFormChanges({
                                    path: "service_starts_at",
                                    value: "",
                                  });
                                }}
                                name="service_starts_at"
                                value={formData?.service_starts_at}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="store_id">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>{t("STORE")}</label>
                              <SelectPicker
                                data={storeList}
                                onSearch={(e: any) => {
                                  if (e) {
                                    storeSearch(e);
                                  }
                                }}
                                valueKey="id"
                                labelKey="store_name"
                                onSelect={(value, item) => {
                                  toggleSchedule(false);
                                  setProducts([]);
                                  setOrderItems([]);
                                  onProductChange([]);
                                  handleFormChanges({
                                    path: "store_id",
                                    value,
                                  });
                                  setShowItemGrid(true);
                                }}
                                onClean={(e: any) => {
                                  toggleSchedule(false);
                                  handleFormChanges({
                                    path: "store_id",
                                    value: "",
                                  });
                                  setShowItemGrid(false);
                                }}
                                name="store_id"
                                value={formData?.store_id}
                                disabled={
                                  +decryptedParams.id > 0 ? true : false
                                }
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      </div>

                      <div className="flex-container">
                        <div className="flex-item">
                          <Button
                            appearance="primary"
                            color="green"
                            type="button"
                            loading={checkingSchedule}
                            onClick={checkSchedule}
                          >
                            {showSchedule ? t("HIDE") : t("SHOW")}
                            {" " + t("AVAILABILITY")}
                          </Button>
                        </div>
                        <Field name="order_serve_at">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("SERVE")} {t("AT")}*
                              </label>

                              <Radio
                                onChangeCapture={(e: any) => {
                                  if (e.target.checked) {
                                    form.change(
                                      "order_serve_at",
                                      orderServeAtObj.store.value,
                                    );
                                  }
                                }}
                                checked={
                                  input.value === orderServeAtObj.store.value
                                    ? true
                                    : false
                                }
                                name="order_serve_at"
                                value={orderServeAtObj.store.value}
                              >
                                {t("STORE")}
                              </Radio>
                              <Radio
                                onChangeCapture={(e: any) => {
                                  if (e.target.checked) {
                                    form.change(
                                      "order_serve_at",
                                      orderServeAtObj.home.value,
                                    );
                                  }
                                }}
                                checked={
                                  input.value === orderServeAtObj.home.value
                                    ? true
                                    : false
                                }
                                name="order_serve_at"
                                value={orderServeAtObj.home.value}
                              >
                                {t("HOME")}
                              </Radio>
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="order_status">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>{t("STATUS")}</label>
                              <SelectPicker
                                data={orderStatusObjArr}
                                valueKey="value"
                                labelKey="label"
                                onSelect={(value, item) => {
                                  handleFormChanges({
                                    path: "order_status",
                                    value,
                                  });
                                }}
                                onClean={(e: any) => {
                                  handleFormChanges({
                                    path: "order_status",
                                    value: "",
                                  });
                                }}
                                name="order_status"
                                value={formData?.order_status}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      </div>
                      {showSchedule && (
                        <OrderScheduleForDay
                          forCompany={getCompanyId()}
                          forStore={formData.store_id}
                          forDay={formData.service_date}
                        />
                      )}
                    </div>
                    <div className="address-bx">
                      <h5>
                        <span>
                          {t("ITEMS")} {t("AMOUNT")}:{" "}
                          <b> {displayAmountField(orderAmount)}</b>
                        </span>
                        {"    "}
                        <span>
                          {t("PAYABLE")}:{" "}
                          <b>{displayAmountField(orderPayableAmount)}</b>
                        </span>
                      </h5>
                    </div>
                    <div>
                      {products.length > 0 && (
                        <span>
                          (
                          {products.map((item: any, index: number) => {
                            return (
                              <span>
                                {item.product_name}
                                {index < products.length - 1 && t(",")}{" "}
                              </span>
                            );
                          })}
                          )
                        </span>
                      )}
                    </div>
                    <div className="form-part ordr-amt">
                      {showItemGrid && (
                        <StoreProductsForOrder
                          key={productForGender}
                          forStore={formData.store_id}
                          withHeader={false}
                          orderProducts={getProductsFromOrderItems(orderItems)}
                          onProductChange={onProductChange}
                          setStopSubmit={setStopSubmit}
                          forGender={productForGender}
                          skipInitialOnProductChange={isEditMode}
                        />
                      )}
                      <div className="flex-container row-field">
                        <div className="flex-item">
                          <label>
                            {t("AMOUNT")}: {displayAmountField(orderAmount)}
                          </label>
                        </div>
                        <div className="flex-item">
                          <label>
                            {t("DISCOUNT")}: {displayAmountField(totalDiscount)}{" "}
                            ({t("AFTER")} {t("DISC")}{" "}
                            {displayAmountField(orderAmountAfterDiscount)})
                          </label>
                        </div>
                        <div className="flex-item">
                          <label>
                            {t("TAX")}: {displayAmountField(orderTax)}
                          </label>
                        </div>
                        <div className="flex-item">
                          <label>
                            {t("PAYABLE")}:{" "}
                            {displayAmountField(orderPayableAmount)}
                          </label>
                        </div>
                      </div>
                      <div className="flex-container row-field">
                        <Field name="additional_cost">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("EXTRA")} {t("COST")} ({t("VARIANCE")}:{" "}
                                {displayAmountField(priceVariance)} )
                              </label>
                              <input
                                {...input}
                                type="number"
                                min={0}
                                step="any"
                                autoComplete="off"
                                onBlur={() => {
                                  onProductChange(products, {
                                    additional_cost: input.value,
                                  });
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="discount_percent">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("DISCOUNT")} % ({t("FINAL")} {t("DISCOUNT")}{" "}
                                {finalDiscountPercent} %)
                              </label>
                              <input
                                {...input}
                                type="number"
                                step="any"
                                min={0}
                                max={100}
                                autoComplete="off"
                                onBlur={() => {
                                  onProductChange(products, {
                                    discount_percent: input.value,
                                  });
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="additional_discount">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("EXTRA")} {t("DISCOUNT")}
                              </label>
                              <input
                                {...input}
                                type="number"
                                step="any"
                                min={0}
                                autoComplete="off"
                                onBlur={() => {
                                  onProductChange(products, {
                                    additional_discount: input.value,
                                  });
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="payment_mode">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("PAYMENT")} {t("MODE")}
                              </label>
                              <SelectPicker
                                data={paymentModeObjArr}
                                valueKey="value"
                                labelKey="label"
                                onSelect={(value, item) => {
                                  handleFormChanges({
                                    path: "payment_mode",
                                    value,
                                  });
                                }}
                                onClean={(e: any) => {
                                  handleFormChanges({
                                    path: "payment_mode",
                                    value: "",
                                  });
                                }}
                                name="payment_mode"
                                value={formData?.payment_mode}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="flex-container row-field">
                        <Field name="order_assigned_to">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("ASSIGNED")} {t("TO")}
                              </label>
                              <SelectPicker
                                data={assignedToList}
                                onSearch={(e: any) => {
                                  if (e) {
                                    //assignedToSearch(e);
                                  }
                                }}
                                valueKey="id"
                                labelKey="name"
                                onSelect={(value, item) => {
                                  toggleSchedule(false);
                                  handleFormChanges({
                                    path: "order_assigned_to",
                                    value,
                                  });
                                  setServiceItemsAssignedTo(value);
                                }}
                                onClean={(e: any) => {
                                  toggleSchedule(false);
                                  handleFormChanges({
                                    path: "order_assigned_to",
                                    value: "",
                                  });
                                  setShowItemGrid(false);
                                }}
                                name="order_assigned_to"
                                value={formData?.order_assigned_to}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="remarks" rows={5}>
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("EXTRA")} {t("SERVICE")}/ {t("PAYMENT")}/
                                {t("REMARKS")}
                              </label>
                              <textarea
                                {...input}
                                autoComplete="off"
                                rows={5}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="customer_order_note" rows={5}>
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label className="mb-mb-2">
                                {t("CUSTOMER")} {t("NOTE")}
                              </label>
                              <textarea
                                {...input}
                                autoComplete="off"
                                rows={5}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                      </div>
                      {orderServiceItems.length > 0 && (
                        <OrderServiceItems
                          orderServiceItems={orderServiceItems}
                          assignedToList={assignedToList}
                          onServiceItemChange={handleServiceItemChange}
                        />
                      )}
                    </div>
                    <div className="create-action d-flex flex-end">
                      <Link to={ContentRoutes.ORDERS}>
                        <Button appearance="primary" color="blue" type="button">
                          {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                          {t("LIST").toLocaleLowerCase()}
                        </Button>
                      </Link>
                      <Button appearance="primary" color="green" type="submit">
                        {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                      </Button>
                      <Button
                        appearance="default"
                        type="reset"
                        onClick={() => {
                          // review comment: move to new function
                          form.reset();
                        }}
                      >
                        {t("RESET")}
                      </Button>
                    </div>
                  </form>
                </>
              )}
            />
          </Content>
        </Container>
      )}
    </div>
  );
};

export default OrderStepOne;
